import "./ColorPreview.scss"

import { FC } from "react"
import cn from "classnames"

interface IColorPreviewProps {
    code?: string | null
    unknown?: boolean
}

const ColorPreview: FC<IColorPreviewProps> = ({
    code,
    unknown,
}) => {
    return (
        <div className={cn("color-preview", { "color-preview--no-color": typeof code === "undefined" || code === "" })}
            style={code && !unknown
            ? { backgroundColor: code }
            : undefined
        }>
            {unknown ? "?" : null}
        </div>
    )
}

export default ColorPreview
